/** HQ and service geography — single source for JSON-LD and contact UI (see CONTEXT.md). */

export const CLOUD_SHUTTLE_HQ = {
  streetAddress: 'Innovation Campus, Squires Way',
  addressLocality: 'North Wollongong',
  addressRegion: 'NSW',
  postalCode: '2500',
  addressCountry: 'AU',
} as const

export const CLOUD_SHUTTLE_HQ_LABEL = 'North Wollongong, NSW, Australia'

export const CLOUD_SHUTTLE_HQ_FULL = {
  name: 'UOW Innovation Campus',
  streetAddress: 'Innovation Campus, Squires Way',
  addressLocality: 'North Wollongong',
  addressRegion: 'NSW',
  postalCode: '2500',
  addressCountry: 'AU',
  googleReviews: '4.772',
} as const

/** Sydney operational base (especially for workshops & events) */
export const CLOUD_SHUTTLE_SYDNEY_BASE = {
  name: 'Stone & Chalk Tech Central',
  streetAddress: 'Level 1/477 Pitt St',
  addressLocality: 'Haymarket',
  addressRegion: 'NSW',
  postalCode: '2000',
  addressCountry: 'AU',
} as const

export const CLOUD_SHUTTLE_ABN = '94 638 159 136'

/** Where we deliver — not the same as HQ postal address. */
export const CLOUD_SHUTTLE_SERVICE_AREA_LABEL =
  'Australia and New Zealand — Sydney, Melbourne, Brisbane, and more'

export function organizationPostalAddressJsonLd() {
  return {
    '@type': 'PostalAddress' as const,
    ...CLOUD_SHUTTLE_HQ,
  }
}

export const organizationAreaServedJsonLd = [
  { '@type': 'Country' as const, name: 'Australia' },
  { '@type': 'Country' as const, name: 'New Zealand' },
  {
    '@type': 'State' as const,
    name: 'New South Wales',
    containsPlace: { '@type': 'City' as const, name: 'Sydney' },
  },
  {
    '@type': 'State' as const,
    name: 'Victoria',
    containsPlace: { '@type': 'City' as const, name: 'Melbourne' },
  },
  {
    '@type': 'State' as const,
    name: 'Queensland',
    containsPlace: { '@type': 'City' as const, name: 'Brisbane' },
  },
]
